var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6669 4.50098H2.3335",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5554 6.16797L12.2488 10.7674C12.1308 12.5373 12.0718 13.4223 11.4952 13.9618C10.9185 14.5013 10.0315 14.5013 8.25768 14.5013H7.7421C5.96824 14.5013 5.0813 14.5013 4.50463 13.9618C3.92796 13.4223 3.86896 12.5373 3.75096 10.7674L3.44434 6.16797",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 7.83398L6.66683 11.1673",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 7.83398L9.3335 11.1673",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 4.50098C4.37075 4.50098 4.38938 4.50098 4.40626 4.50055C4.95522 4.48664 5.43951 4.13758 5.62631 3.62119C5.63205 3.60531 5.63794 3.58763 5.64972 3.55229L5.71445 3.35812C5.7697 3.19236 5.79733 3.10948 5.83397 3.03911C5.98017 2.75836 6.25066 2.5634 6.56324 2.51349C6.64158 2.50098 6.72895 2.50098 6.90367 2.50098H9.09666C9.27138 2.50098 9.35874 2.50098 9.43709 2.51349C9.74967 2.5634 10.0202 2.75836 10.1664 3.03911C10.203 3.10948 10.2306 3.19236 10.2859 3.35812L10.3506 3.55229C10.3624 3.58759 10.3683 3.60532 10.374 3.62119C10.5608 4.13758 11.0451 4.48664 11.5941 4.50055C11.611 4.50098 11.6296 4.50098 11.6668 4.50098",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete1);
export default __webpack_public_path__ + "static/media/delete1.f488053c485381d1a12b03dc0a568375.svg";
export { ForwardRef as ReactComponent };